<template>
	<div class='vb-damages'>
		<span class='title'>Повреждения породы</span>
		<button @click='enableAddMode'>Добавить повреждение</button>
		<div class='add-block-outer' v-if='addMode'>
			<AddBlock :current-species='currentSpecies' @close='disableAddMode'/>
		</div>
		<template v-if='!currentSpecies.damages.length'>
			<div>
				<span>Повреждений нет</span>
			</div>
		</template>
		<template v-else>
			<table class='table-def'>
				<thead>
					<tr>
						<th>Категория состояния</th>
						<th>Причина</th>
						<th>Признак</th>
						<th>Доля от запаса породы, %</th>
						<!-- <th>Рубка</th> -->
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for='damage in currentSpecies.damages' :key="damage.id" >
						<td>{{ damage.state_cat }}</td>					
						<td>{{ damage.reason }}</td>
						<td>{{ damage.symptom }}</td>
						<td>{{ damage.symptom_proc }}</td>
						<!-- <td><i class='fa fa-check' v-if='damage.is_felling === "t"'></i></td> -->
						<td><button @click='remove(damage)'><i class='fa fa-trash'></i></button></td> 
					</tr>
				</tbody>
			</table>
		</template>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import AddBlock from './Recount__bvSheetDamagesAdd';

	export default {
		name: 'RecountVbSheetDamages',
		components: {
			AddBlock
		},
		props: {
			currentSpecies: {
				type: Object,
				default: null
			},
		},
		data: () => ({
			addMode: false
		}),
		computed: {

			...mapState('selectedLpo/recount', {
				vbList: state => state['vbList'],
			})
		},

		methods: {
			enableAddMode() {
				this.addMode = true;
			},
			disableAddMode() {
				this.addMode = false;
			},

			remove(damage) {
				this.removeVbDamage(damage).then(res => {
					this.updateVbList();
				});
			},

			...mapActions('selectedLpo/recount', [
				'removeVbDamage',
				'updateVbList',
			]),
		},

	};
</script>

<style scoped src='@/style/table.css'></style>

<style scoped>
	.vb-damages .title {
		font-size: 1rem;
		display: inline-block;
		margin-top: 16px;
		margin-bottom: 14px;
		margin-right: 10px;
		font-weight: bold;
	}
</style>